module.exports = __webpack_public_path__ + "static/media/mixkit-arcade-bonus-alert-767.ea81242.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios/mixkit-arcade-bonus-alert-767.wav
// module id = jgRm
// module chunks = 1